export default __webpack_public_path__ + "static/media/gallery_02.454a5f46.jpg";